import * as Constants from '../../../constants';

let nodeID = $('#market-watch').data('nodeid');

export default {
	getWatches(page) {

		return fetch(Constants.ENVIRONMENT_API + `reports/watches?parentNodeID=` + nodeID + `&page=` + page)
			.then(response => {
				if (response.ok) {
					return Promise.resolve(response);
				}
				else {
					return Promise.reject(new Error(error));
				}
			})
			.then(response => response.json())
			.then(data => {
				// stuff on success
				return data.Data;
			})
			.catch(error => {
				console.log(error);
			});
	}
};